import React, { Fragment } from "react";
import styled from "@emotion/styled";
import { TypographyT36 } from "Components/Common/Typography/index";
import { Spacer } from "Components/Common/Spacer/index";
const ModalCardT3 = (props) => {
  const { children, title } = props;
  return (
    <Fragment>
      <ModalCardT1Wrapper>
        <TypographyT36>{title}</TypographyT36>
        <Spacer spacing={"10px"} />
        {children}
      </ModalCardT1Wrapper>
    </Fragment>
  );
};

export default ModalCardT3;

const ModalCardT1Wrapper = styled.div`
  border-radius: 8px;
  background: #f6f9ff;
  padding: 20px 24px;
`;
